module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- src/app/commons/templates/LeaveEmployeeChooser.html -->\n<!-- Employee -->\n<div class="form-group">\n    <label class="col-sm-3 control-label">\n        Employee\n    </label>\n    <div class="col-sm-9">\n        <select name="employeeId" data-placeholder="Choose an employee..."\n            class="js-ext js-employee-select chosen-select">\n            <option></option>\n            ';
 employees.each(function (employee) { 
__p+='\n                <option value="'+
((__t=( employee.id ))==null?'':_.escape(__t))+
'">\n                    '+
((__t=( employee.get('fullName') ))==null?'':_.escape(__t))+
'\n                </option>\n            ';
 }) 
__p+='\n        </select>\n    </div>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/commons/templates/LeaveEmployeeChooser.html
// module id = 912
// module chunks = 1